import moment from 'moment';
import {currentResource, numberFormattedText} from '../../../../util/utils';
import {defaultDateFormat, defaultNumberFormat, materialityTypes} from '../../../../util/uiconstants';
import Utility from '../../../../util/utilityfunctions';
import {isNullOrUndefined} from '../../../../util/utils';

export const getMeasurementBasisLabel = (materialityTypeId, otherBasisDescription, helixBasis) => {
	if (materialityTypeId) {
		// If  MaterialityTypeId is "Other" then display the Basis values from HelixJson Entry.
		if (materialityTypeId === materialityTypes.Other && helixBasis) return helixBasis;

		let materialityType = currentResource?.materialityTypes?.find(
			(materialityType) => materialityType.value === materialityTypeId
		);

		if (
			(materialityTypeId === materialityTypes.Other ||
				materialityTypeId === materialityTypes.CapitalBasedOther ||
				materialityTypeId === materialityTypes.EarningsBasedOther) &&
			!isNullOrUndefined(otherBasisDescription) &&
			otherBasisDescription !== ''
		) {
			return materialityType.label + ' - ' + otherBasisDescription;
		}

		if (materialityType?.label) return materialityType.label;
	}
	return '-';
};

export const getInUserNumberFormat = (value, userPreferences) => {
	if (value !== null) {
		value = Math.round(value);
		return numberFormattedText(
			userPreferences.numberFormat ? userPreferences.numberFormat : defaultNumberFormat, // If user's preferred setting is not available use default number format
			value
		);
	}

	return '-';
};

export const getInUserDateFormat = (value, userPreferences) => {
	if (value) {
		let dateFormat = userPreferences.dateFormat ? userPreferences.dateFormat : defaultDateFormat;

		let newValue = moment(value).format(Utility.convertUserPreferencesDateFormatToMoment(dateFormat));

		return newValue;
	}

	return '-';
};

export const getAnnualizedAmount = (basisAmount, elapsedPeriods, totalPeriods) => {
	return basisAmount * (totalPeriods / elapsedPeriods);
};

export const getFinancialPeriodAmountInUserFormat = (isEditingInput, value, userPreferences) => {
	let numberFormat = userPreferences.numberFormat ? userPreferences.numberFormat : defaultNumberFormat;

	if (!isEditingInput) {
		return numberFormattedText(numberFormat, value === null || !isNumeric(value) ? '' : value);
	} else {
		if (value === null) {
			return '';
		} else {
			return value;
		}
	}
};

const isNumeric = (number) => {
	return !isNaN(number);
};
